// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"187":"bf30a417","213":"066a6e39","239":"9883b0e8"}[chunkId] + ".chunk.js";
};